import React from 'react';
import {Wrap, WrapItem} from '@chakra-ui/react';

import {FaLayerGroup, FaPrint, FaSearch, FaHammer, FaFileDownload} from 'react-icons/fa';
import Card from '../../components/Maintenance/IconCard';

const Surveys = props => {
  // static displayName = FetchData.name;

  const reportScreens = [
    {Name: 'Survey Lookup', Icon: FaSearch, RouteName: 'lookup'},
    {Name: 'Print Surveys', Icon: FaPrint, RouteName: 'print'},
    {Name: 'Batch Lookup', Icon: FaLayerGroup, RouteName: 'batch'},
    {Name: 'Export Survey CSV', Icon: FaFileDownload, RouteName: 'export'},
  ];
  return (
    <div>
      <Wrap mt={'10'}>
        {reportScreens.map((screen, idx) => {
          return (
            <WrapItem key={idx}>
              <Card name={screen.Name} icon={screen.Icon} route={'/surveys/' + screen.RouteName} />
            </WrapItem>
          );
        })}
      </Wrap>
    </div>
  );
};

export default Surveys;
